var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5"},[_c('div',{staticClass:"d-flex justify-content-between title-container py-3"},[_vm._t("title"),_c(_setup.CloseButton,{on:{"click":_setup.handleClick}})],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }